import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-border-inner",
  templateUrl: "./med-icon-border-inner.component.html",
})
export class MedIconBorderInnerComponent extends SvgMixinComponent {}
